const navHeight = 64; //px
const scrollSpeed = 600; //ms

$(document).ready(function() {
    $(".navbar .nav-link, .scroll").on('click', function(e) {
       // console.log('clicked')
       const navLink = this;
       const hash = navLink.hash;

       if( hash && $(hash).length  ) {
            e.preventDefault();

            const top = $(hash).offset().top - navHeight;

            $('html, body').animate({ scrollTop: top }, scrollSpeed);

            $('.nav-link').removeClass('active');
            $(navLink).addClass('active');
        };
    });
});

// store the hash (DON'T put this code inside the $() function, it has to be executed
// right away before the browser can start scrolling!
var target = window.location.hash;

// delete hash so the page won't scroll to it
history.pushState(null, null, ' ')

// now whenever you are ready do whatever you want
// (in this case I use jQuery to scroll to the tag after the page has loaded)
// $(window).on('load', function() {
//     if (target) {
//         $('html, body').animate({
//             scrollTop: $(target).offset().top - navHeight
//         }, 500, function () {});
//     }
// });

$(document).ready(function() {
    onScroll();
    $(document).on("load", onScroll);
    $(document).on("scroll", onScroll);

})

function onScroll(event) {
    const scrollPos = $(document).scrollTop();
    // // win.scroll(function(event) {
    let fadeInElements = $(".fade-in");
    let fadeInStepsElements = $(".fade-in-steps");
    let fadeInUpElements = $(".fade-in-up");
    let fadeInRightElements = $(".fade-in-right");
    let fadeInLeftElements = $(".fade-in-left");

    fadeInElements.each(function(i, element) {
        if ( $(element).visible(true) ) {
            element.classList.add('animate__animated', 'animate__fadeIn');
        }
    });

    fadeInStepsElements.each(function(i, element) {
        if ( $(element).visible(true) ) {
            let timer = 0;
            $(element).children().each(function(i, item) {
                $(item).css('opacity', 0);
                setTimeout(function(){
                    item.classList.add('animate__animated', 'animate__fadeIn');
                }, timer * 400)
                timer++;
            })
        }
    });
    //
    // fadeInUpElements.each(function(i, element) {
    //     if ( $(element).visible(true) ) {
    //         element.classList.add('animate__animated', 'animate__fadeInUp');
    //     }
    // });
    //
    // fadeInRightElements.each(function(i, element) {
    //     if ( $(element).visible(true) ) {
    //         element.classList.add('animate__animated', 'animate__fadeInRight');
    //     }
    // });
    //
    // fadeInLeftElements.each(function(i, element) {
    //     if ( $(element).visible(true) ) {
    //         element.classList.add('animate__animated', 'animate__fadeInLeft');
    //     }
    // });

    // });
    $('#navbar-menu .nav-section').each(function () {
        const currLink = $(this);
        const id = currLink.attr("href").substring(currLink.attr("href").lastIndexOf('#'));
        const refElement = $(id);
        if (refElement.length && refElement.position().top <= $(window).scrollTop() + $(window).height() / 2 && refElement.position().top + refElement.height() > $(window).scrollTop() + $(window).height() / 2 ) {
            $('#navbar-menu a').removeClass("active");
            currLink.addClass("active");
        }
        else{
            currLink.parents('li').removeClass("active");
        }
    });

}
